
<div>
  <h2>Administrera förkortningslistor</h2>
  <div class="d-flex justify-content-between align-items-center">
    <h4>Verktygslåda</h4>
    <b-badge>Visa/dölj med ALT+1</b-badge>
  </div>
  <div v-if="show.toolbox">
    <b-button @click="$bvModal.show('batchImportModal')"
      >Importera till användare</b-button
    >
  </div>
  <div v-else>
    <b-badge>...</b-badge>
  </div>
  <div class="d-flex justify-content-between align-items-center">
    <h4>Alla listor</h4>
    <b-badge>Visa/dölj med ALT+2</b-badge>
  </div>
  <div v-if="show.lists">
    <b-table
      responsive
      fluid
      sticky-header
      small
      striped
      hover
      :items="lists"
      :fields="fields"
      :sort-by="sortBy"
      sort-desc
      @sort-changed="sortChanged"
    >
      <template #cell(type)="row">
        <span v-if="row.item.type">Ämneslista</span
        ><span v-else>Standardlista</span> </template
      ><template #cell(download)="row">
        <b-button @click="downloadList(row.item.id, row.item.owner)">
          <b-icon icon="download" />
        </b-button>
      </template>
    </b-table>
  </div>
  <div v-else>
    <b-badge>...</b-badge>
  </div>

  <b-modal
    id="batchImportModal"
    title="Importera till användare"
    size="lg"
    hide-footer
  >
    <div v-if="batchImport.upload">
      <b-form @submit.prevent="uploadBatchImport">
        <b-form-group label="Användare">
          <b-form-select v-model="batchImport.user" autofocus required>
            <option :value="null">Välj användare...</option>
            <option value="all">Auto</option>
            <option v-for="user in users" :key="user.id" :value="user">
              {{ user.name }}
            </option>
          </b-form-select>
        </b-form-group>
        <b-form-group label="Ladda upp en eller flera listor">
          <b-form-file
            v-model="batchImport.files"
            multiple
            accept=".json"
            required
          />
        </b-form-group>
        <b-button type="submit">Ladda upp</b-button>
      </b-form>
    </div>
    <div v-else>
      <b-form
        @submit.prevent="confirmBatchImport"
        @reset.prevent="resetBatchImport"
      >
        <b-list-group
          v-for="pending in pendingLists"
          :key="pending.creator + '_' + pending.id"
        >
          <b-list-group-item>
            <div class="d-flex justify-content-between align-items-center">
              <span>{{ pending.creator_name }}</span
              ><span>{{ pending.name }}</span>
              <span v-if="!pending.clean">
                <b-badge variant="success">{{ pending.new }}</b-badge>
                <b-badge variant="danger">{{
                  pending.conflicts.length
                }}</b-badge>
                <b-button
                  variant="warning"
                  @click="confirmSingleImport(pending)"
                  >Importera</b-button
                >
              </span>
              <span v-else>
                <b-badge variant="success">{{ pending.new }}</b-badge>
                <b-button @click="confirmSingleImport(pending)"
                  >Skapa</b-button
                >
              </span>
            </div>
          </b-list-group-item>
        </b-list-group>
        <b-button type="reset">Gå tillbaka</b-button>
        <b-button type="submit">Importera allt</b-button>
      </b-form>
    </div>
  </b-modal>
</div>
